import {stringify} from 'qs'
import {format} from 'utils'
import api from 'message-control/common/api/sensitive-behavior'
import request from 'message-control/utils/request'

// sensitive-behavior-record页面
export async function records(params) {
    return request(`${api.records.url}?${stringify(params)}`)
}

export async function updateRecord(params = {}) {
    return request(format(api.updateRecord.url), {
        method: api.updateRecord.type,
        body: params.body,
    })
}

export async function types() {
    return request(api.types.url)
}

export async function exportRecords(params) {
    return request(`${api.exportRecords.url}?${stringify(params)}`, null, {
        returnResponse: true,
    })
}

// 敏感行为管理

export async function behaviors(params) {
    return request(`${api.behaviors.url}?${stringify(params)}`)
}

export async function updateBehaviorStatus(payload) {
    return request(api.updateBehaviorStatus.url, {
        method: api.updateBehaviorStatus.type,
        body: payload.body,
    })
}
